import React from 'react'

interface CompletedSubmissionCardSkeletonProps {
  count?: number
}

const SkeletonBar: React.FC<{ width?: string; height?: string; className?: string }> = ({
  width = 'w-full',
  height = 'h-4',
  className = '',
}) => (
  <div className={`bg-secondary/20 rounded animate-pulse ${width} ${height} ${className}`} />
)

const CompletedSubmissionCardSkeleton: React.FC<CompletedSubmissionCardSkeletonProps> = ({ count = 4 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-4"
        >
          <div className="flex items-start md:items-center gap-4">
            {/* Icon */}
            <SkeletonBar width="w-11" height="h-11" className="rounded-lg flex-shrink-0" />

            <div className="flex-1 min-w-0">
              {/* Title + badges row */}
              <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                <SkeletonBar width="w-48" height="h-5" />
                <SkeletonBar width="w-16" height="h-4" className="rounded-full" />
                <SkeletonBar width="w-20" height="h-4" className="rounded-full" />
              </div>
              {/* Meta row */}
              <div className="flex items-center gap-2 flex-wrap">
                <SkeletonBar width="w-12" height="h-4" className="rounded-full" />
                <SkeletonBar width="w-1" height="h-3" />
                <SkeletonBar width="w-16" height="h-3" />
                <SkeletonBar width="w-1" height="h-3" />
                <SkeletonBar width="w-28" height="h-3" />
              </div>
            </div>

            {/* Right side: chevron + menu */}
            <div className="hidden md:flex items-center gap-2 flex-shrink-0">
              <SkeletonBar width="w-4" height="h-4" />
              <SkeletonBar width="w-8" height="h-8" className="rounded-md" />
            </div>

            <div className="md:hidden flex items-center flex-shrink-0">
              <SkeletonBar width="w-8" height="h-8" className="rounded-md" />
            </div>
          </div>
        </div>
      ))}
    </>
  )
}

export { CompletedSubmissionCardSkeleton }
